
        var result = require("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].use[1]!../../../node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[7].use[2]!./legacy_form_templates.less?scoped");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    